<template>
    <BaseDialog :title="infoDialogConfig.title" :visible="infoDialogVisible" append-to-body width="800px" @close="close">
        <template slot="body">
            <el-form :model="form" :rules="rules" ref="form" label-width="150px" label-position="right">
                <el-row>
                    <el-col :span="12">
                                <el-form-item label="申请数量" prop="applySqsl">
                                    <el-input-number v-model="form.applySqsl"  :min="1" label="请输入数量" :disabled="disabledBol"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="标签样式" prop="tagYs">
                                    <enuSelect style="width:100%;" filterable v-model="form.tagYs" :list='bqysList' placeholder="请选择标签样式" :disabled="disabledBol"></enuSelect>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="标签规格" prop="tagGg">
                                    <enuSelect style="width:100%;" filterable v-model="form.tagGg" :list='bqggList' placeholder="请选择标签规格" :disabled="disabledBol"></enuSelect>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="申请人姓名" prop="applyUserName">
                                    <el-input v-model="form.applyUserName"  placeholder="请输入申请人姓名" :disabled="disabledBol"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="申请时间" prop="applyTime">
                                    <el-input v-model="form.applyTime"  placeholder="请输入申请时间" :disabled="disabledBol"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="备注" >
                                    <el-input type="textarea" :rows="2" v-model="form.applyDesc"  placeholder="请输入备注" :disabled="disabledBol"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="申请状态" prop="tagZt">
                                    <enuSelect style="width:100%;" filterable v-model="form.tagZt" :list='bqztList' placeholder="请选择状态" ></enuSelect>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="处理实际发货量">
                                    <el-input v-model="form.handFhl"  placeholder="请输入处理实际发货量"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="处理人姓名" >
                                    <el-input v-model="form.handUserName"  placeholder="请输入处理人姓名" :disabled="disabledBol"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="处理时间" >
                                    <el-input v-model="form.handTime"  placeholder="请输入处理时间" :disabled="disabledBol"></el-input>
                                </el-form-item>
                            </el-col>
                </el-row>

            </el-form>
        </template>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </BaseDialog>
</template>

<script>
    export default {
        name: "infoDialog",
        props: {
            infoDialogConfig: {
                type: Object,
                default: () => {
                },
            },
            infoDialogVisible: {
                type: Boolean,
                default: () => false,
            },
        },
        data() {
            return {
                disabledBol:true,
                form: {
                    tagApplyId: '',
                    applySqsl: '',
                    tagYs: '',
                    tagGg: '',
                    tagZt: '',
                    applyUserId: '',
                    applyUserName: '',
                    applyTime: '',
                    applyDesc: '',
                    createName: '',
                    createId: '',
                    createTime: '',
                    handFhl: '',
                    handUserId: '',
                    handUserName: '',
                    handTime: '',
                },
                rules: {
                    applySqsl: [{
                        required: true,
                        message: "请输入申请数量",
                        trigger: "submit",
                    },],
                    tagYs: [{
                        required: true,
                        message: "请输入标签样式",
                        trigger: "submit",
                    },],
                    tagGg: [{
                        required: true,
                        message: "请输入标签规格",
                        trigger: "submit",
                    },],
                    tagZt: [{
                        required: true,
                        message: "请输入状态",
                        trigger: "submit",
                    },],
                    applyUserId: [{
                        required: true,
                        message: "请输入申请人ID",
                        trigger: "submit",
                    },],
                    applyUserName: [{
                        required: true,
                        message: "请输入申请人姓名",
                        trigger: "submit",
                    },],
                    applyTime: [{
                        required: true,
                        message: "请输入申请时间",
                        trigger: "submit",
                    },],
                    applyDesc: [{
                        required: true,
                        message: "请输入备注",
                        trigger: "submit",
                    },],
                    createName: [{
                        required: true,
                        message: "请输入创建人姓名",
                        trigger: "submit",
                    },],
                    createId: [{
                        required: true,
                        message: "请输入创建人",
                        trigger: "submit",
                    },],
                    handFhl: [{
                        required: true,
                        message: "请输入处理实际发货量",
                        trigger: "submit",
                    },],
                    handUserId: [{
                        required: true,
                        message: "请输入处理人ID",
                        trigger: "submit",
                    },],
                    handUserName: [{
                        required: true,
                        message: "请输入处理人姓名",
                        trigger: "submit",
                    },],
                    handTime: [{
                        required: true,
                        message: "请输入处理时间",
                        trigger: "submit",
                    },],
                },
                options: [],
                dialogVisible: false,
            };
        },
        computed: {},
        mounted() {
            this.bqysList = this.infoDialogConfig.bqysList;
            this.bqggList = this.infoDialogConfig.bqggList;
            this.bqztList = this.infoDialogConfig.bqztList;
            if (this.infoDialogConfig.data) {
                for (const key in this.infoDialogConfig.data) {
                    for (const k in this.form) {
                        if (key === k) {
                            this.form[k] = this.infoDialogConfig.data[key];
                        }
                    }
                }
            }
        },

        methods: {
            close() {
                this.$emit("update:infoDialogVisible", false);
            },
            confirm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = JSON.parse(JSON.stringify(this.form));
                        if (params.tagApplyId) {
                            this.$api
                                .formPost("/api/major/tag/tagApply/doHandById", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        } else {
                            delete params.tagApplyId;
                            this.$api
                                .formPost("/api/major/tag/tagApply/doSave", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        }
                    }
                });
            },

        },
    };
</script>

<style lang="scss" scoped>
    .userInfo {
        width: 240px;
        display: flex;
        flex-direction: column;
        height: 100%;

    .info {
        font-size: var(--text-size);
        display: flex;
        justify-content: space-between;
        padding: 13px 0px;
        border-bottom: 1px solid #ccc;

    .title {
        min-width: 70px;
    }
    }
    }

    .avatar-uploader {
        width: 100%;
        border: 1px dotted #ccc;
        text-align: center;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 240px;
        height: 240px;
        line-height: 240px;
        text-align: center;
    }

    .avatar {
        width: 240px;
        height: 240px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/tag/tagApplyHand/components/infoDialog.vue